import React from 'react';
import { GetUserFullName, getEmptyValue, getApiDTNZFormat } from 'helpers';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { openConfirmation } from 'helpers/Confirmation';
import { withAppContext } from '@ctsu/loader';
import { compose, withHandlers, withState } from 'recompose';
import { TE, httpStatusEnum } from 'appconstants';
import { GridTable, GridSubmitAction } from '@ctsu/ctsu-mui-grid';
import { withChangeHandlers } from 'helpers/Change';
import { BoolToString } from "components";
// import { MUIDateTimePicker } from 'components/FormHelpers/DatePicker';
import { saveCohortData} from 'actions/protocols/protocoldetail';
import { openSnackbar } from 'helpers/Notifier';
import {
  TableRow, TableCell, ListItem, ListItemText
} from '@material-ui/core';
import _ from 'lodash';
import { bindLogger } from 'helpers/BindLogger';
import { ValidatorForm,  MUISelect, MUITextBox } from 'components/FormHelpers/FormInputs';
import { CohortsColumns } from '../gridcolumns';

const EditCohort = ({ state, handleChange, cancel, reset, loadStatusRecords, data }) => {
  const {
    cohortName,
    status,
    statusReason,
    statusDate,
    targetAccrual,
    description,
    currentAccrual,
    stratums
  } = state;
  
  return (
    <TableRow className="state">
      <TableCell>{cohortName}</TableCell>
      <TableCell>{stratums ? <BoolToString boolValue={stratums.length > 0}  /> : '' } </TableCell>
      <TableCell>{description}</TableCell>
      <TableCell>
        <MUISelect
          value={getEmptyValue(status)}
          name="status"
          onChange={handleChange}
          title="Status"
        >
          {_.map(loadStatusRecords(data.status), (item, i) => (
            <ListItem
              button
              key={_.uniqueId('status_sel')}
              value={item.value}
            >
              <ListItemText primary={item.label} />
            </ListItem>
          ))}
        </MUISelect>
      </TableCell>
      <TableCell>
        <MUITextBox
          title="Status Reason"
          value={getEmptyValue(statusReason)}
          onChange={handleChange}
          validators={[]}
          errorMessages={[]}
          name="statusReason"
        />
      </TableCell>
      <TableCell>{statusDate}</TableCell>
      <TableCell>
        <MUITextBox
          title="Target Accrual"
          value={getEmptyValue(targetAccrual)}
          onChange={handleChange}
          validators={['matchRegexp:^[0-9]+$']}
          errorMessages={['Please enter numeric value']}
          name="targetAccrual"
        />
      </TableCell>
      <TableCell>{currentAccrual}</TableCell>
      <TableCell align='center'>
        <GridSubmitAction
          cancel={cancel}
          reset={reset}
        />
      </TableCell>
    </TableRow>
  );
};

export const EditCohorts = compose(withChangeHandlers)(EditCohort);

let setEditingCohortFlag;

const CohortsGrid = props => {
  const {
    cohortData,
    CanUserEditCohorts,
    highlightObj,
    setHighlighted,
    onLoad, rowClick,
    handleHistory, prtInfo,
    context, state, setState,
    saveCohort,
    loadStatusRecords
    } = props;

  const RenderEditRow = (row, setEditing) => {
    if (_.isEmpty(state) && !_.isEqual(row, state)) {
      setState({ ...row });
    }

    setEditingCohortFlag = (flg) => {
      setEditing(flg);
      setState({});
    };

    return (
      <EditCohorts
        state={state || row}
        setEditing={setEditing}
        setState={setState}
        context={context}
        data={row}
        prtId={prtInfo.prtId}
        loadStatusRecords={loadStatusRecords}
      />
    );
  };

  const handleSave = () => {
    const cohortObj = {...state};
    delete cohortObj.stratums
    saveCohort(cohortObj);
  };

  return (
    <ValidatorForm onSubmit={handleSave}>
      <GridTable
        tag={`${TE.ID}cohorts${TE.TABLE}`}
        title="Cohorts"
        id="CohortsDataGrid"
        rows={cohortData}
        editable={CanUserEditCohorts}
        editMode={CanUserEditCohorts}
        rowEvents={[handleHistory]}
        columns={CohortsColumns}
        user={GetUserFullName()}
        recordPerPage={5}
        enableToolbar
        onDataLoad={onLoad}
        highlightRowObject={highlightObj}
        onFilter={(object, field) => {
          setHighlighted(field);
        }}
        exportable={false}
        onRowClicked={rowClick}
        rowEditable={() => CanUserEditCohorts}
        renderEditRow={RenderEditRow}
        toPdf={false}
      />
    </ValidatorForm>
  );
};

const withConnectState = connect(
  state => {
    return {
      cohortData: state.prtDetails.cohortData,
      prtInfo: state.prtDetails.prtInfo
    };
  },
  dispatch => bindActionCreators({
    onSaveCohort: saveCohortData
  }, dispatch)
);

const Cohorts = compose(
  withAppContext,
  withConnectState,
  withState('state', 'setState', {}),
  withHandlers({
    saveCohort: props => postBody => {
      const {
        onSaveCohort, context, prtInfo
      } = props;
      const statusDate = getApiDTNZFormat(postBody.statusDate);
      const confirmSaveChohort = () => {
        bindLogger(onSaveCohort, context)(prtInfo.prtId, {...postBody, statusDate})
          .subscribe(resp => {
            if (resp.status === httpStatusEnum.SUCCESS) {
              setEditingCohortFlag(false);
              openSnackbar({
                message: 'Cohort saved successfully.',
                variant: 'success',
                name: 'versions'
              });
            }
          });
      };
      openConfirmation({
        message:  'Do you want to save cohort record?',
        onAction: confirmSaveChohort,
        name: 'cohort'
      });
    },
    deleteCohort: props => verId => {
      setEditingCohortFlag(false);
    }
  }),
  withHandlers({
    handleHistory: ({loadHistory, onOpenModal}) => (evt,row) => {
      onOpenModal({
        type: 'CohortHistory',
        title: `Cohort Change History- Cohort ${row.cohortName}`,
        data: null
      });
      loadHistory(evt, row.pmcId);
    }
  })
)(CohortsGrid);
export { Cohorts };
